<template>
 <v-navigation-drawer
    v-model="opened"
    height="100vh"
    width="350"
    location="right"
    floating
    fixed
    temporary
    hide-overlay
    class="drawer-info">

    <div class="header-drawer">
      <span >Detalles</span>
        <v-icon class="mr-2"
        @click="opened = false">
          mdi-close
        </v-icon>
    </div>

    <div class="container-data-drawer">
      <div class="container-element-drawer">
        <span class="title-elemet-drawer">Creado</span>
        <span class="element-drawer">{{ formatTimestamp(pos.created_at) }}</span>
      </div>

      <div class="container-element-drawer">
        <span class="title-elemet-drawer">Punto de venta</span>
        <span class="element-drawer">{{ pos.name }}</span>
      </div>

      <div class="container-element-drawer">
        <span class="title-elemet-drawer">Descripción</span>
        <span class="element-drawer">{{ pos.description }}</span>
      </div>
    </div>

    <div class="container-bottom-drawer">
      <v-btn
        color="#FF5700"
        class="btn-outline-drawer"
        variant="outlined"
        rounded="xl"
        @click="openEdit">
        Editar
      </v-btn>
    </div>

  </v-navigation-drawer>
</template>
<script>
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueTerminalsDrawer',
  emits: ['openEditPos'],
  data () {
    return {
      opened: false,
      pos: {
        _id: null,
        business: null,
        name: null,
        description: null,
        active: null,
        created_at: null,
        updated_at: null
      }
    }
  },

  methods: {
    show (pos) {
      this.opened = true
      this.pos = structuredClone(pos)
      this.panelOpen = [0]
    },
    openEdit () {
      this.opened = false
      this.$emit('openEditPos', this.pos)
    },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/drawers.css';
</style>
